import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-regions-dialog',
  templateUrl: './regions-dialog.component.html',
  styleUrls: ['./regions-dialog.component.scss']
})
export class RegionsDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
